import { Link } from 'react-router-dom';
import { InsightCategoryType, InsightGroup } from '@/queries/insights';
import { useInsights } from '@/hooks/use-insights';
import { Button } from '@/isomorphic/components/typography/button/button';

export type AllTermsProps = {
    labels: {
        title?: string;
        showAllButtonText: string;
    };
};

export const AllTerms = ({ labels }: AllTermsProps) => {
    const { basePath, sortedTerms } = useInsights();

    const renderTerm = ({ id, slug, title }: InsightCategoryType, group: InsightGroup = 'private') => (
        <Link
            key={id}
            to={`${basePath}/${slug}?group=${group}`}
            className="r-rounded-md r-border r-border-tertiary-500 r-p-4 r-font-bold r-text-tertiary-500 hover:r-bg-tertiary-500 hover:r-text-white"
        >
            {title}
        </Link>
    );

    return (
        <div data-component="all-terms" className="r-container r-mb-8 r-px-4 r-py-8">
            {labels?.title && <h2 className="r-pb-6 r-text-3xl r-font-medium">{labels.title}</h2>}
            <div className="r-flex r-max-w-3xl r-flex-wrap r-gap-4 r-pb-6">
                {[...sortedTerms['private']].map(term => renderTerm(term))}
                {[...sortedTerms['corporate']].map(term => renderTerm(term, 'corporate'))}
            </div>
            <Button to={basePath}>{labels.showAllButtonText}</Button>
        </div>
    );
};
